import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import {
  CANCEL_BOOKING,
  RESCHEDULE_BOOKING,
  VERIFY_MODIFY_BOOKING,
  VIEW_APPOINTMENTS,
  VIEW_GET_OTP,
} from '../type';
import {
  viewGetOtpActionSuccess,
  viewGetOtpActionError,
  viewAppointmentsActionSuccess,
  viewAppointmentsActionError,
  verifyModifyBookingActionSuccess,
  verifyModifyBookingActionError,
  cancelBookingActionSuccess,
  cancelBookingActionError,
  rescheduleBookingActionSuccess,
  rescheduleBookingActionError,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { viewBookingsService } from 'services';

function* viewGetOtp() {
  while (1) {
    const action = yield take(VIEW_GET_OTP);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        viewBookingsService.view_GET_OTP,
        action.payload,
      );
      if (!response) {
        throw Error('No booking found');
      }
      notification.success({
        message: MessengerResource.verifyCode.sendCodeSuccess,
      });
      callback && callback(response);

      yield put(viewGetOtpActionSuccess(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.sendCodeError,
        description: error.message,
      });
      yield put(viewGetOtpActionError(error));
    }
  }
}

function* viewAppointments() {
  while (1) {
    const action = yield take(VIEW_APPOINTMENTS);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        viewBookingsService.viewAppointments,
        action.payload,
      );
      callback && callback(response);

      yield put(viewAppointmentsActionSuccess(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.verifyError,
        description: error.message,
      });
      yield put(viewAppointmentsActionError(error));
    }
  }
}

function* verifyModifyBooking() {
  while (1) {
    const action = yield take(VERIFY_MODIFY_BOOKING);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        viewBookingsService.verifyModifyBooking,
        action.payload,
      );
      notification.success({
        message: MessengerResource.verifyCode.sendCodeSuccess,
      });
      callback && callback(response);

      yield put(verifyModifyBookingActionSuccess(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.sendCodeError,
        description: error.message,
      });
      yield put(verifyModifyBookingActionError(error));
    }
  }
}

function* cancelBooking() {
  while (1) {
    const action = yield take(CANCEL_BOOKING);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        viewBookingsService.cancelBooking,
        action.payload,
      );
      notification.success({
        message: MessengerResource.verifyCode.sendCodeSuccess,
      });
      callback && callback(response);

      yield put(cancelBookingActionSuccess(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.verifyError,
        description: error.message,
      });
      yield put(cancelBookingActionError(error));
    }
  }
}

function* rescheduleBooking() {
  while (1) {
    const action = yield take(RESCHEDULE_BOOKING);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        viewBookingsService.rescheduleBooking,
        action.payload,
      );
      callback && callback(response);
      yield put(rescheduleBookingActionSuccess(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.verifyCode.verifyError,
        description: error.message,
      });
      yield put(rescheduleBookingActionError(error));
    }
  }
}

export default function* rootSaga() {
  yield all([
    viewGetOtp(),
    viewAppointments(),
    verifyModifyBooking(),
    cancelBooking(),
    rescheduleBooking(),
  ]);
}
